<template>
    <section class="container space-y-10 lg:space-y-20">
        <div
            v-if="data.description"
            v-html="data.description"
            class="tinyeditor text-16/148 font-medium text-accent-100 md:w-3/4" />

        <BlockCard
            v-for="block in otherBlocks"
            :key="block.id"
            :block-id="block.id"
            :block-type="blockTypes[block.type]"
            :text="block.text"
            :image="block.images ? block.images[0] : null"
            :title="block.title"
            :link-rutube="block.link"
            :autoplay-video="block.video ? block.video[0] : null"
            :preview-rutube="
                block.preview_rutube ? block.preview_rutube[0] : null
            "
            :row-reverse="
                ['Изображение + текст', 'Видео + текст'].includes(
                    block.type_name
                )
            " />

        <DocumentsSection
            v-if="documents.length"
            :items="documents" />
    </section>
</template>

<script setup lang="ts">
import type { ProductLineModelRangeDescription } from '~/types/pages.types'

import BlockCard from '~/components/particles/block-card/BlockCard.vue'
import type { TBlockType } from '~/components/particles/block-card/block-card.types'
import DocumentsSection from '~/components/particles/documents-section/DocumentsSection.vue'
import type { IProductLineBlock } from '~/components/particles/product-line-blocks-section/product-line-blocks-section.types'

const props = defineProps({
    data: {
        type: Object as PropType<ProductLineModelRangeDescription>,
        required: true,
    },
})

const blockTypes: { [key: number]: TBlockType } = {
    1: 'text',
    2: 'image',
    3: 'video',
    4: 'text + video',
    5: 'text + image',
    6: 'text + image',
    7: 'text + video',
    8: 'video',
}

const documents = computed<IProductLineBlock[]>(() => {
    return (
        props.data.blocks.data.filter((block: IProductLineBlock) => {
            return block.type === 9
        }) || []
    )
})

const otherBlocks = computed<IProductLineBlock[]>(() => {
    return (
        props.data.blocks.data.filter((block: IProductLineBlock) => {
            return block.type !== 9
        }) || []
    )
})
</script>
